<template>
	<!-- 结果弹窗 -->
	<a-modal v-model="visible" :title="tableInfoByFrom.modal_title" :width="800" :bodyStyle="bodyStyle" :footer="null" id="UploadResult">
		<div class="result-container">
			<div class="result-list">
				<div class="item">
					<div class="title">{{ tableInfoByFrom.total_name }}</div>
					<div class="value">{{ total }}</div>
				</div>
				<a-divider type="vertical" />
				<div class="item">
					<div class="title">{{ tableInfoByFrom.success_name }}</div>
					<div class="value">{{ success }}</div>
				</div>
				<a-divider type="vertical" />
				<div class="item">
					<div class="title">{{ tableInfoByFrom.error_name }}</div>
					<div class="value err">{{ error }}</div>
				</div>
			</div>
			<div class="result-title">失败列表</div>
			<a-table :columns="tableInfoByFrom.columns" :data-source="resultData" :row-key="(record) => record[tableInfoByFrom.key]" :scroll="{ y: '300px' }" :pagination="false"> 
				<template slot="text" slot-scope="text">
					{{ text || '-' }}
				</template>
				<template slot="operation" slot-scope="text, record">
					<template v-if="record._actions && record._actions.length">
						<a-button
							v-for="action in record._actions"
							:key="action.key"
							type="link"
							@click="handleRecordAction(action, record)"
						>
							{{ action.text }}
						</a-button>
					</template>
					<template v-else>-</template>
				</template>
			</a-table>
		</div>
	</a-modal>
</template>

<script>
import Core from '../../core';

const realityCardColumns = [
	{
		title: '卡号',
		dataIndex: 'uid',
		scopedSlots: { customRender: 'uid' },
		align: 'center',
		width: '50%',
	},
];

const pursueOrderColumns = [
	{
		title: '序号',
		dataIndex: 'index',
		scopedSlots: { customRender: 'index' },
		align: 'center',
		width: '50%',
	},
	{
		title: '订单号',
		dataIndex: 'id',
		scopedSlots: { customRender: 'id' },
		align: 'center',
		width: '50%',
	},
];

const userManageColumns = [
	// {
	//     title: '序号',
	//     dataIndex: 'id',
	//     scopedSlots: { customRender: 'id' },
	//     align: 'center',
	// },
	{
		title: '手机号',
		dataIndex: 'phone',
		scopedSlots: { customRender: 'phone' },
		align: 'center',
		width: '50%',
	},
	{
		title: '姓名',
		dataIndex: 'username',
		scopedSlots: { customRender: 'name' },
		align: 'center',
		width: '50%',
	},
];


// 更改站点所属
const stationAllotColumns = [
	// {
	//     title: '序号',
	//     dataIndex: 'id',
	//     scopedSlots: { customRender: 'id' },
	//     align: 'center',
	// },
	{
		title: '站点名称',
		dataIndex: 'name',
		scopedSlots: { customRender: 'name' },
		align: 'center',
		width: '50%',
	},
	{
		title: '失败原因',
		dataIndex: 'reason',
		scopedSlots: { customRender: 'reason' },
		align: 'center',
		width: '50%',
	},
	{
		title: '操作',
		dataIndex: 'operation',
		scopedSlots: { customRender: 'operation' },
		align: 'center',
		width: '50%',
	},
];

export default {
	components: {},
	props: {},
	data() {
		return {
			visible: false,
			total: 0,
			success: 0,
			error: 0,
			resultData: [],
			bodyStyle: {
				padding: '40px 20px 31px',
			},
			from: '',
			key: '',
			// 业务方传入的上下文，供 visible/handler 使用（例如 operator_id、org_id）
			resultContext: {},
			// 运行时配置：由调用方在 handleModalShow 第4参传入
			runtimeConfig: {
				// 失败列表归一化函数: (list, context, from) => normalizedList
				normalize_error_list: null,
				// 行操作配置: [{ key, text, visible?, handler? }]
				record_actions: [],
			},
		};
	},
	computed: {
		tableInfoByFrom() {
			let obj = {
				key: 'uid',
				columns: [],
				modal_title: '导入结果',
				total_name: '总数据',
				success_name: '导入成功',
				error_name: '导入失败',
			}
			switch (this.from) {
				case 'reality-card-list':
					obj.key = 'uid';
					obj.columns = realityCardColumns;
					obj.modal_title = '导入结果';
					obj.total_name = '总数据';
					obj.success_name = '导入成功';
					obj.error_name = '导入失败';
					break;
				case 'pursue-order-list':
					obj.key = 'id';
					obj.columns = pursueOrderColumns;
					obj.modal_title = '结算结果';
					obj.total_name = '总数据';
					obj.success_name = '结算成功';
					obj.error_name = '结算失败';
					break;
				case 'user-manage-list':
					obj.key = 'phone';
					obj.columns = userManageColumns;
					obj.modal_title = '导入结果';
					obj.total_name = '总数据';
					obj.success_name = '导入成功';
					obj.error_name = '导入失败';
					break;
				case 'station-allot-list':
					obj.key = 'id';
					obj.columns = stationAllotColumns;
					obj.modal_title = '更改所属结果';
					obj.total_name = '更改数量';
					obj.success_name = '成功';
					obj.error_name = '失败';
					break;
				case 'batch-station-allot-list':
					obj.key = 'id';
					obj.columns = stationAllotColumns;
					obj.modal_title = '批量更改所属结果';
					obj.total_name = '更改数量';
					obj.success_name = '成功';
					obj.error_name = '失败';
					break;
			}
			return obj;
		},
	},
	mounted() {},
	methods: {
		// 每次打开弹窗前重置动态配置，避免上一次场景污染本次场景
		resetRuntimeConfig() {
			this.runtimeConfig = {
				normalize_error_list: null,
				record_actions: [],
			};
		},
		// 允许业务方按场景改写失败项（补字段、打标签等）
		normalizeResultList(list = [], context = {}) {
			const normalizeErrorList = this.runtimeConfig.normalize_error_list;
			if (typeof normalizeErrorList === 'function') {
				return normalizeErrorList(list, context, this.from);
			}
			return list;
		},
		// 根据业务配置筛选当前行可展示的动作按钮
		getRecordActions(record = {}) {
			const actions = this.runtimeConfig.record_actions || [];
			return actions.filter(action => {
				if (!action || typeof action !== 'object') return false;
				if (typeof action.visible === 'function') {
					return action.visible(record, this.resultContext, this.from);
				}
				return action.visible !== false;
			});
		},
		// 点击动作后回调到业务方，组件本身不感知具体业务行为
		handleRecordAction(action = {}, record = {}) {
			if (typeof action.handler === 'function') {
				action.handler(record, this.resultContext, this.from);
			}
		},
		/**
		 * 统一打开结果弹窗入口
		 * @param {String} from 场景标识（决定标题、列配置）
		 * @param {Object} data 结果数据 { count, error_count, error_list }
		 * @param {Object} context 业务上下文，会透传给 visible/handler
		 * @param {Object} config 运行时配置
		 *   - normalize_error_list(list, context, from): 失败项归一化
		 *   - record_actions: 行操作配置
		 */
		handleModalShow(from = 'reality-card-list', data, context = {}, config = {}) {
			console.log('handleModalShow  from:', from, 'data:', data);
			if (Core.Util.isEmptyObj(data)) return;

			this.from = from;
			this.resultContext = context || {};
			this.resetRuntimeConfig();
			this.runtimeConfig = {
				...this.runtimeConfig,
				...(config || {}),
			};

			let list = this.normalizeResultList(data.error_list || [], context);
			list = list.map((item, index) => ({
				...item,
				index: index + 1,
				// 缓存当前行动作，避免模板重复执行 getRecordActions
				_actions: this.getRecordActions(item),
			}));
			console.log('handleModalShow list:', list);

			this.resultData = list;
			this.total = data.count;
			this.error = data.error_count;
			this.success = data.count - data.error_count;
			
			this.visible = true;
		},
	},
};
</script>

<style lang='scss'>
#UploadResult {
	.result-container {
		.result-list {
			display: flex;
			align-items: center;
			.item {
				text-align: center;
				width: calc((100% - 2px) / 3);
				.title {
					font-size: 14px;
					font-weight: 400;
					color: rgba(0, 0, 0, 0.85);
				}
				.value {
					font-size: 24px;
					font-weight: 500;
					color: rgba(0, 0, 0, 0.85);
					&.err {
						color: #f75658;
					}
				}
			}
		}
		.result-title {
			margin: 30px 0 20px;
			font-size: 14px;
			font-weight: 400;
			color: #000022;
		}
		.ant-divider-vertical {
			height: 40px;
			background: #eaedf0;
			margin: 0px;
		}
	}

	.ant-modal-content .ant-modal-close .ant-modal-close-x i.anticon {
		font-size: 16px;
	}

	.ant-table-wrapper {
		.ant-table-header {
			position: sticky;
			top: 0;
			z-index: 3;
			background: transparent;
		}
		.ant-table-sticky-scroll {
			position: sticky;
			bottom: 0;
			z-index: 3;
		}
		.ant-table-body {
			overflow-y: auto !important;
			padding-right: 15px;
		}
	}
}
</style>